/* M58 · GARAGEVÆLGEREN (2026-10-23) — sections/m58-garage.liquid.
   Kundens cykel: {vy, label} (årgangslinje i fitment-registeret) eller {ohv: 'model|motor', label} (Ohvale, §11's matrice), gemt i
   localStorage «m58_cykel». Data og dom fra vores server gennem app-proxyen (/apps/m58 → 02_pim/shopify_proxy.py):
     garage/maerker · garage/modeller · garage/aar · garage/passer (kun «passer», aldrig «passer ikke» — Michael 2026-09-22).
   Badges: produktsiden ([data-m58-fit-handle]) og alle produktkort på siden (Maranellos .card-product og M58's .m58-pcard),
   genkendt på linket /products/‹handle›. Nye kort (filtre, «indlæs flere») fanges af en MutationObserver. Emoji-fri. */
(function () {
  'use strict';
  var rod = document.querySelector('[data-m58-garage]');
  if (!rod || rod.getAttribute('data-m58-klar')) return;
  rod.setAttribute('data-m58-klar', '1');
  var PROXY = rod.getAttribute('data-proxy') || '/apps/m58';
  var NOEGLE = 'm58_cykel';
  var dlg = rod.querySelector('dialog');
  var sel = {
    make: rod.querySelector('[data-m58-g="make"]'), model: rod.querySelector('[data-m58-g="model"]'),
    year: rod.querySelector('[data-m58-g="year"]'), motor: rod.querySelector('[data-m58-g="motor"]')
  };
  var felt = { year: rod.querySelector('[data-m58-g-felt="year"]'), motor: rod.querySelector('[data-m58-g-felt="motor"]') };
  var navn = rod.querySelector('[data-m58-g-navn]'), se = rod.querySelector('[data-m58-g-se]');
  var gemKnap = rod.querySelector('[data-m58-g-gem]'), rydKnap = rod.querySelector('[data-m58-g-ryd]'), fejl = rod.querySelector('[data-m58-g-fejl]');
  var ohvaleModeller = null;

  function laes() {
    try { var c = JSON.parse(localStorage.getItem(NOEGLE) || 'null'); return c && c.label && (c.vy || c.ohv) ? c : null; } catch (e) { return null; }
  }
  function skriv(c) {
    try { if (c) localStorage.setItem(NOEGLE, JSON.stringify(c)); else localStorage.removeItem(NOEGLE); } catch (e) { /* privat vindue: cyklen gælder kun denne side */ }
    nu = c;
  }
  var nu = laes();
  function param(c) { return c.vy ? 'vy=' + encodeURIComponent(c.vy) : 'ohv=' + encodeURIComponent(c.ohv); }
  function hent(sti) {
    return fetch(PROXY + sti, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function valg(s, liste, tom) {
    s.innerHTML = '';
    var o = document.createElement('option'); o.value = ''; o.textContent = tom; s.appendChild(o);
    liste.forEach(function (x) { var e = document.createElement('option'); e.value = x.v; e.textContent = x.t; s.appendChild(e); });
    s.disabled = !liste.length;
  }
  function visFejl(t) { fejl.textContent = t || ''; fejl.hidden = !t; }

  // ------------------------------------------------------------------ bjælken
  function visBjaelke() {
    navn.textContent = nu ? nu.label : 'Vælg motorcykel';
    rod.classList.toggle('has-bike', !!nu);
    se.hidden = !nu;
    if (nu) se.href = PROXY + '/min-cykel?' + param(nu);
    rydKnap.hidden = !nu;
  }

  // ------------------------------------------------------------------ vælgeren
  var maerkerHentet = false;
  function aabn() {
    visFejl('');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    if (maerkerHentet) return;
    hent('/garage/maerker').then(function (d) {
      maerkerHentet = true;
      var liste = d.maerker.map(function (m) { return { v: m.make, t: m.make }; });
      valg(sel.make, liste, 'Vælg mærke…');
      if (liste.length > 1) {   // Ohvale først, så en skillelinje før registerets mærker
        var sk = document.createElement('option'); sk.disabled = true; sk.textContent = '──────────';
        sel.make.insertBefore(sk, sel.make.options[2]);
      }
    }).catch(function () { visFejl('Mærkerne kunne ikke hentes lige nu. Prøv igen om lidt.'); });
  }
  function luk() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  function erOhvale() { return sel.make.value.toLowerCase() === 'ohvale'; }
  function opdaterGem() { gemKnap.disabled = !(sel.make.value && sel.model.value && (erOhvale() ? sel.motor.value : sel.year.value)); }

  sel.make.addEventListener('change', function () {
    visFejl('');
    var o = erOhvale();
    felt.year.hidden = o; felt.motor.hidden = !o;
    valg(sel.model, [], 'Henter modeller…'); valg(sel.year, [], 'Vælg model først'); valg(sel.motor, [], 'Vælg model først');
    opdaterGem();
    if (!sel.make.value) { valg(sel.model, [], 'Vælg mærke først'); return; }
    hent('/garage/modeller?make=' + encodeURIComponent(sel.make.value)).then(function (d) {
      if (d.ohvale) {
        ohvaleModeller = d.modeller;
        valg(sel.model, d.modeller.map(function (m) { return { v: m.model, t: m.model + (m.legacy ? ' (tidligere model)' : '') }; }), 'Vælg model…');
      } else {
        valg(sel.model, d.modeller.map(function (m) {
          var aar = m.year_from ? ' (' + m.year_from + (m.year_to && m.year_to !== m.year_from ? '–' + m.year_to : '') + ')' : '';
          return { v: m.model, t: m.model + aar };
        }), 'Vælg model…');
      }
    }).catch(function () { visFejl('Modellerne kunne ikke hentes lige nu. Prøv igen om lidt.'); });
  });
  sel.model.addEventListener('change', function () {
    visFejl(''); opdaterGem();
    if (!sel.model.value) return;
    if (erOhvale()) {
      var m = (ohvaleModeller || []).filter(function (x) { return x.model === sel.model.value; })[0];
      valg(sel.motor, (m ? m.motorer : []).map(function (x) { return { v: x, t: x }; }), 'Vælg motor…');
      return;
    }
    valg(sel.year, [], 'Henter årgange…');
    hent('/garage/aar?make=' + encodeURIComponent(sel.make.value) + '&model=' + encodeURIComponent(sel.model.value)).then(function (d) {
      valg(sel.year, d.aar.map(function (a) { return { v: String(a.vy), t: String(a.year) }; }), 'Vælg årgang…');
    }).catch(function () { visFejl('Årgangene kunne ikke hentes lige nu. Prøv igen om lidt.'); });
  });
  sel.year.addEventListener('change', opdaterGem);
  sel.motor.addEventListener('change', opdaterGem);

  gemKnap.addEventListener('click', function () {
    var c;
    if (erOhvale()) c = { ohv: sel.model.value + '|' + sel.motor.value, label: 'Ohvale ' + sel.model.value + ' ' + sel.motor.value };
    else c = { vy: sel.year.value, label: sel.make.value + ' ' + sel.model.value + ' ' + sel.year.options[sel.year.selectedIndex].text };
    skriv(c); visBjaelke(); luk(); badges(true);
    document.dispatchEvent(new CustomEvent('m58:cykel', { detail: c }));
  });
  rydKnap.addEventListener('click', function () {
    skriv(null); visBjaelke(); luk(); badges(true);
    document.dispatchEvent(new CustomEvent('m58:cykel', { detail: null }));
  });
  rod.querySelector('[data-m58-g-aabn]').addEventListener('click', aabn);
  rod.querySelector('[data-m58-g-luk]').addEventListener('click', luk);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) luk(); });   // klik på baggrunden lukker

  // ------------------------------------------------------------------ badges
  function handleAf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    try { return m ? decodeURIComponent(m[1]).toLowerCase() : null; } catch (e) { return null; }
  }
  function kort(omraade) {
    var ud = [];
    (omraade || document).querySelectorAll('.card-product, .m58-pcard').forEach(function (k) {
      var a = k.matches('a[href*="/products/"]') ? k : k.querySelector('a[href*="/products/"]');
      var h = a && handleAf(a);
      if (h) ud.push({ el: k, h: h });
    });
    return ud;
  }
  function fjernBadges() {
    document.querySelectorAll('.m58-fitbadge--kort').forEach(function (b) { b.remove(); });
    document.querySelectorAll('[data-m58-fit-handle]').forEach(function (e) { e.hidden = true; e.textContent = ''; });
    document.querySelectorAll('[data-m58-fit]').forEach(function (e) { e.removeAttribute('data-m58-fit'); });
  }
  var noegleNu = function () { return nu ? param(nu) : ''; };
  function badges(forfra, omraade) {
    if (forfra) fjernBadges();
    if (!nu) return;
    var n = noegleNu();
    var side = [].slice.call(document.querySelectorAll('[data-m58-fit-handle]')).filter(function (e) { return e.getAttribute('data-m58-fit') !== n; });
    var k = kort(omraade).filter(function (x) { return x.el.getAttribute('data-m58-fit') !== n; });
    var pr = {};
    side.forEach(function (e) { var h = e.getAttribute('data-m58-fit-handle'); (pr[h] = pr[h] || []).push({ el: e, side: true }); e.setAttribute('data-m58-fit', n); });
    k.forEach(function (x) { (pr[x.h] = pr[x.h] || []).push({ el: x.el }); x.el.setAttribute('data-m58-fit', n); });
    var handles = Object.keys(pr);
    for (var i = 0; i < handles.length; i += 200) {
      (function (del) {
        hent('/garage/passer?' + n + '&h=' + del.map(encodeURIComponent).join(',')).then(function (d) {
          if (noegleNu() !== n) return;                              // cyklen er skiftet imens
          Object.keys(d.passer || {}).forEach(function (h) {
            (pr[h] || []).forEach(function (x) {
              if (x.side) { x.el.textContent = d.passer[h]; x.el.hidden = false; return; }
              if (x.el.querySelector('.m58-fitbadge--kort')) return;
              var b = document.createElement('span');
              b.className = 'm58-fitbadge m58-fitbadge--kort'; b.textContent = d.passer[h];
              var vaert = x.el.querySelector('.card-info, .m58-pcard__bd') || x.el;
              vaert.insertBefore(b, vaert.firstChild);
            });
          });
        }).catch(function () { /* ingen dom = intet badge; aldrig et gæt */ });
      })(handles.slice(i, i + 200));
    }
  }
  var vent = null;
  new MutationObserver(function (mut) {
    if (!nu) return;
    var nyt = mut.some(function (m) { return [].some.call(m.addedNodes, function (x) { return x.nodeType === 1 && (x.matches('.card-product, .m58-pcard') || x.querySelector && x.querySelector('.card-product, .m58-pcard')); }); });
    if (!nyt) return;
    clearTimeout(vent); vent = setTimeout(function () { badges(false); }, 250);
  }).observe(document.body, { childList: true, subtree: true });

  visBjaelke();
  badges(false);
})();
